<template>
  <div>
    <v-dialog v-model="isOpen" lazy persistent max-width="1100">
      <v-card class="RealizationModal">
        <v-card-title class="headline">Szczegóły vouchera</v-card-title>
        <v-card-text>
          <v-container class="pt-0 pb-0" grid-list-md>
            <div class="row">
              <div class="col-12 col-xl-6" style="border-right: solid 2px lightgrey">
                <table class="table table-hover table-sm">
                  <tbody>
                  <tr>
                    <td class="font-weight-bold">Nr vouchera</td>
                    <td>#{{voucherDetails.voucher_number}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Nr faktury/paragonu</td>
                    <td>{{voucherDetails.invoice_number}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Imię i nazwisko</td>
                    <td>{{voucherDetails.name}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Nazwa vouchera</td>
                    <td>{{voucherDetails.type ? voucherDetails.type.name : 'Brak'}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Opis usługi</td>
                    <td>
                      <span>{{voucherDetails.service_type}}</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Status</td>
                    <td>{{voucherDetails.status | convertTypeToName}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Data utworzenia</td>
                    <td>{{moment(voucherDetails.created_at).format('DD-MM-YYYY HH:mm')}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Termin ważności</td>
                    <td>{{moment(voucherDetails.expired_at).format('DD-MM-YYYY')}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Ostatnia aktualizacja</td>
                    <td>{{moment(voucherDetails.updated_at).format('DD-MM-YYYY HH:mm')}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Wartość</td>
                    <td>PLN {{voucherDetails.price}}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Pokaż cenę</td>
                    <td>{{voucherDetails.show_price | boolToStr }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Faktura do vouchera</td>
                    <td>{{voucherDetails.has_invoice | boolToStr }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Dodano przez</td>
                    <td>{{voucherDetails.user ? voucherDetails.user.name : 'Brak'}}
                      {{voucherDetails.user ? voucherDetails.user.surname : 'Brak'}}
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-12 col-xl-6">
                <v-data-table
                  :rows-per-page-items="[]"
                  :headers="getRealizationsHeaders"
                  :items="voucherDetails.realizations"
                  :pagination.sync="paginationData"
                  sort-icon="fa-arrow-down" class="elevation-1 sub-table"
                >
                  <template slot="items" slot-scope="props">
                    <td>
                      <v-tooltip left v-if="props.item.comments">
                        <template v-slot:activator="{ on }">
                          <v-icon size="15px" class="icon-btn" v-on="on">fas fa-info-circle</v-icon>
                        </template>
                        <div v-html="props.item.comments" style="white-space: pre;"/>
                      </v-tooltip>
                    </td>
                    <td class="text-center">{{
                      moment(props.item.realizated_at).format('DD-MM-YYYY')}}
                    </td>
                    <td class="text-center">{{ props.item.user.name }} {{
                      props.item.user.surname}}
                    </td>
                    <td class="white-space-nowrap text-center">PLN {{ props.item.price | currency
                      }}
                    </td>
                  </template>
                  <template slot="footer"
                            v-if="voucherDetails.realizations && voucherDetails.realizations.length > 0">
                    <td></td>
                    <td></td>
                    <td class="text-center"><strong>SUMA</strong></td>
                    <td class="text-center">
                      <strong>PLN {{showPricesSum(voucherDetails.realizations) }}</strong>
                    </td>
                  </template>
                </v-data-table>
              </div>
            </div>
          </v-container>
        </v-card-text>
        <section class="col-12 pb-4 pr-4 pl-4" v-if="voucherDetails.internal_note">
          <strong style="font-size: 1rem" class="pl-3">Notatka wewnętrzna</strong>
          <div class="pl-2 pr-2">
            <hr class="mt-1 mb-2">
          </div>
          <span class="pl-5 pr-5">{{voucherDetails.internal_note}}</span>
        </section>
        <section class="col-12 pr-4 pl-4" v-if="voucherDetails.status_reason">
          <strong style="font-size: 1rem" class="pl-3">Powód zakończenia</strong>
          <div class="pl-2 pr-2">
            <hr class="mt-1 mb-2">
          </div>
          <span class="pl-5 pr-5">{{voucherDetails.status_reason}}</span>
        </section>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" small flat @click="$router.push({name: 'Vouchers'})">
            Zamknij
          </v-btn>
          <v-menu bottom offset-y>
            <v-btn color="primary darken-1" small slot="activator" class="mr-0" flat>
              Więcej
              &nbsp;<v-icon size="15px">fas fa-caret-down</v-icon>
            </v-btn>
            <v-list class="v-list--button-list">
              <v-list-tile v-permissions v-if="voucherDetails.status !== 'F'"
                           @click="$router.push({name: 'EditExpiredAtFromDetails', params: {voucherId: voucherDetails.id}})">
                <v-list-tile-title>Edycja daty</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-permissions v-if="voucherDetails.status !== 'F'"
                           @click="$router.push({name: 'EditPriceFromDetails', params: {voucherId: voucherDetails.id}})">
                <v-list-tile-title>Edycja wartości</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="printPDF(voucherDetails.id)">
                <v-list-tile-title>Drukuj</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-permissions v-if="voucherDetails.status === 'N'"
                           @click="deleteVoucher = true; "
                           class="v-menu--v-list-title-delete">
                <v-list-tile-title>Usuń</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="voucherDetails.status && voucherDetails.status !== 'F'"
                           @click="$router.push({name: 'EditVoucherFromDetails', params: {voucherId: voucherDetails.id}})"
              >
                <v-list-tile-title>Edytuj</v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="voucherDetails.status === 'I'"
                           @click="openDeactivateVoucher = true; showTextarea = true;"
                           class="v-menu--v-list-title-delete">
                <v-list-tile-title>Zakończ</v-list-tile-title>
              </v-list-tile>
              <v-list-tile
                @click="exportPDF(voucherDetails.id, `${voucherDetails.id}_${moment(voucherDetails.created_at).format('YYYY')}`, voucherDetails.type ? voucherDetails.type.name : 'Brak')">
                <v-list-tile-title>Eksportuj PDF</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn v-if="voucherDetails.status !== 'F'" small color="#555474"
                 @click="$router.push({name: 'AddRealizationFromDetails', params: {voucherId: voucherDetails.id}})"
                 flat>
            Dodaj realizację
          </v-btn>
        </v-card-actions>
      </v-card>
      <DeleteModal
        :open="deleteVoucher"
        deleteText="Czy na pewno chcesz usunąć voucher?"
        @close="deleteVoucher = false"
        @accept="deleteOneVoucher(id); deleteVoucher = false"
      ></DeleteModal>
      <DeleteModal
        :open="openDeactivateVoucher"
        :show-textarea="true"
        deleteText="Czy na pewno chcesz zakończyć voucher?"
        @close="openDeactivateVoucher = false"
        @accept="disableVoucher"
      ></DeleteModal>
    </v-dialog>
    <router-view></router-view>
  </div>
</template>

<script>
  /* eslint-disable no-unused-expressions */

  import {mapGetters, mapActions} from 'vuex';
  import FileSaver from 'file-saver';
  import printJS from 'print-js';
  import DeleteModal from '../Globals/ModalDelete.vue';
  import {getPDF} from '../../services/api.service';


  export default {
    name: 'VoucherDetails',
    components: {
      DeleteModal,
    },
    data() {
      return {
        isOpen: true,
        loading: true,
        editVoucherDate: false,
        openDeactivateVoucher: false,
        voucherDetails: {},
        finishVoucherDate: new Date().toISOString()
          .substr(0, 10),
        finishVoucherDatePicker: false,
        deleteVoucher: false,
        types: ['Hotel', 'SPA', 'Restaurant', 'Full', 'New year party', '2019'],
        paginationData: {
          descending: false,
          page: 1,
          rowsPerPage: 15,
        },
      };
    },
    mounted() {
      this.fetchVoucherDetails(this.$route.params.voucherId)
        .then((response) => {
          this.voucherDetails = response;
          this.loading = false;
        });
    },
    watch: {
      $route(from) {
        if (from.name === 'VoucherDetails') {
          this.loading = true;
          this.fetchVoucherDetails(this.$route.params.voucherId)
            .then((response) => {
              this.voucherDetails = response;
              this.loading = false;
            });
        }
      },
    },
    computed: {
      ...mapGetters('VoucherStore', ['getMainTableHeaders', 'getRealizationsHeaders']),
    },
    methods: {
      ...mapActions('VoucherStore', ['fetchVoucherDetails', 'removeVoucher', 'turnOffVoucher', 'downloadPDF']),
      refreshVoucherDetails() {
        this.loading = true;
        this.fetchVoucherDetails(this.$route.params.voucherId)
          .then((response) => {
            this.voucherDetails = response;
            this.loading = false;
          });
      },
      async exportPDF(id, number, type) {
        const response = await getPDF(`/voucher/realization/pdf/${id}`);
        const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        FileSaver.saveAs(blob, `${number} - ${type} - ${this.moment(new Date())
          .format('DD-MM-YYYY')} - export`);
      },
      disableVoucher(formData) {
        this.openDeactivateVoucher = false;
        this.turnOffVoucher({
          id: this.$route.params.voucherId,
          formData,
        })
          .then(() => {
            this.refreshVoucherDetails(this.$route.params.voucherId);
          });
      },
      deleteOneVoucher(id) {
        this.removeVoucher(id)
          .then(() => {
            this.$emit('close');
          });
      },
      async printPDF(id) {
        const response = await getPDF(`/pdf/${id}`);
        const blob = new Blob([response.data], {
          type: 'application/pdf',
        });
        printJS(URL.createObjectURL(blob));
      },
      showPricesSum(data) {
        if (data && data.length > 1) {
          return data
            .map(item => item.price)
            .reduce((previousVal, currentVal) => parseFloat(previousVal) + parseFloat(currentVal))
            .toFixed(2);
        }
        return parseFloat(data
          .map(item => item.price), 2)
          .toFixed(2);
      },
    },
    filters: {
      convertTypeToName(type) {
        switch (type) {
          case 'F':
            return 'Zakończone';
          case 'N':
            return 'Nowe';
          case 'I':
            return 'W realizacji';
          default:
            return 'Nieznany status';
        }
      },
      currency(number) {
        return parseFloat(number)
          .toFixed(2);
      },
      boolToStr(value) {
        if (value) return 'Tak';
        return 'Nie';
      },
    },
  };
</script>

<style scoped>

</style>
